import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import EuroSymbol from '@mui/icons-material/EuroSymbol';
import OfferInsuranceSummary from './OfferInsuranceSummary';
import OfferInsurance from './OfferInsurance';
import WrappedFakeText from 'components/common/WrappedFakeText';
import { CollapseCard } from '@totalsoft/rocket-ui';

export const OfferInsuranceCard = ({
  insurance,
  products,
  companies,
  onProductPropertyChange,
  onInsurancePropertyChange,
  t,
  insuranceLoading,
  productsLoading,
  isDirty,
  saving,
  onSave,
  isValid
}) => {
  const [state, setState] = useState({
    expanded: false,
    prevSaving: false
  });

  if (saving !== state.prevSaving) {
    setState({
      prevSaving: saving,
      expanded: !saving && !isDirty ? false : state.expanded
    });
  }

  const toggleExpanded = useCallback(() => {
    setState(prev => ({ ...prev, expanded: !prev.expanded }));
  }, []);

  return (
    <CollapseCard
      id={'offerInsuranceCard'}
      icon={EuroSymbol}
      title={t('OfferEdit.Insurance.Title')}
      expanded={state.expanded}
      onToggle={toggleExpanded}
      subheader={!insuranceLoading && <OfferInsuranceSummary insurance={insurance} products={products} />}
      hideSubheaderOnExpand
      toggleOnHeaderClick
    >
      {insuranceLoading ? (
        <WrappedFakeText lines={6} />
      ) : (
        <OfferInsurance
          insurance={insurance}
          products={products}
          companies={companies}
          onInsurancePropertyChange={onInsurancePropertyChange}
          onProductPropertyChange={onProductPropertyChange}
          onSave={onSave}
          saving={saving}
          insuranceLoading={insuranceLoading}
          productsLoading={productsLoading}
          isDirty={isDirty}
          isValid={isValid}
        />
      )}
    </CollapseCard>
  );
};

OfferInsuranceCard.propTypes = {
  t: PropTypes.func.isRequired,
  insurance: PropTypes.object.isRequired,
  products: PropTypes.array,
  companies: PropTypes.array.isRequired,
  onInsurancePropertyChange: PropTypes.func.isRequired,
  onProductPropertyChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  insuranceLoading: PropTypes.bool.isRequired,
  productsLoading: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool.isRequired,
  isValid: PropTypes.bool
};

export default withTranslation()(OfferInsuranceCard);
